import React from "react";

const Experience = () => {
  return (
    <div
      name="experience"
      className="h-auto w-screen bg-gradient-to-b from-[#0e0c49] via-[#221d7e] to-[#0e0c49] text-white"
    >
      <div className="p-4 max-w-screen-lg mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-20">
          <p className="text-4xl font-bold inline border-b-4 border-white">
            Experience
          </p>
        </div>
        <ol className="relative border-l border-gray-200 dark:border-gray-700">
          <li className="mb-10 ml-4">
            <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>

            <time className="mb-1 text-sm font-normal leading-none text-gray-50 dark:text-gray-500">
              September 2025 - Present
            </time>

            <h3 className="text-lg font-semibold dark:text-white">
              Software Engineer
            </h3>

            <h6 className="text-sm font-semibold dark:text-white">
              Subtlelabs – (Product+Service)-Based Company
            </h6>

            <p className="text-base font-normal text-gray-50 dark:text-gray-400 mt-2">
              At Subtlelabs, I work as a Software Engineer primarily focused on
              backend development using Django. My role involves designing and
              building scalable backend services that process and manage large
              volumes of data from multiple third-party POS platforms such as
              Shopify, Lightspeed, Shyfter, and Shipday. I focus on creating
              efficient data pipelines and ensuring seamless data flow between
              external systems and internal applications.
            </p>

            <p className="text-base font-normal text-gray-50 dark:text-gray-400 mt-2">
              Alongside backend development, I contribute to frontend analytics
              by developing dynamic dashboards using AG Grid and AG Charts,
              enabling better data visualization and decision-making. I am also
              working on a cross-platform mobile application using React Native,
              building features like authentication, job listings, and user
              management for a workforce management platform.
            </p>

            <p className="text-base font-normal text-gray-50 dark:text-gray-400 mt-4">
              <b>Key Contributions & Qualities:</b>
            </p>

            <ul className="list-disc list-inside text-gray-50 dark:text-gray-400">
              <li>
                Designed and developed scalable backend services using Django
                and REST APIs.
              </li>
              <li>
                Integrated multiple third-party POS APIs (Shopify, Lightspeed,
                Shyfter, Shipday) and mapped external data to internal data
                models.
              </li>
              <li>
                Implemented role-based authentication and authorization for
                secure access control.
              </li>
              <li>
                Built dynamic and high-performance data tables using AG Grid.
              </li>
              <li>
                Developed interactive analytics dashboards using AG Charts.
              </li>
              <li>
                Optimized backend performance for handling large-scale data
                processing.
              </li>
              <li>
                Contributed to cross-platform mobile development using React
                Native for Android and iOS.
              </li>
              <li>
                Worked with Android Studio and Xcode for building and testing
                mobile applications.
              </li>
              <li>
                Collaborated with cross-functional teams in an Agile environment
                for feature delivery.
              </li>
            </ul>
          </li>
          <li className="mb-10 ml-4">
            <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>

            <time className="mb-1 text-sm font-normal leading-none text-gray-50 dark:text-gray-500">
              February 2025 - Present
            </time>

            <h3 className="text-lg font-semibold dark:text-white">
              Frontend Developer
            </h3>

            <h6 className="text-sm font-semibold dark:text-white">
              Wisdom Tree Ventures (Zeply) – Product-Based Company
            </h6>

            <p className="text-base font-normal text-gray-50 dark:text-gray-400 mt-2">
              At Wisdom Tree Ventures (Zeply), a dynamic food delivery platform,
              I work as a Frontend Developer focusing on crafting highly
              interactive and user-friendly experiences using Next.js and
              Tailwind CSS. My responsibilities include developing and
              maintaining the dine-in section for both users and admins,
              ensuring seamless interactions and a consistent design system
              across all pages.
            </p>

            <p className="text-base font-normal text-gray-50 dark:text-gray-400 mt-2">
              I took charge of making the entire admin panel responsive for
              mobile and tablet devices, significantly enhancing usability for
              on-the-go management. Additionally, I integrated and refined the
              chat support feature for real-time communication between users and
              support staff, improving customer service efficiency. I also
              contributed to the “Party” section, adding new UI features and
              improving interactivity for users hosting group dining
              experiences.
            </p>

            <p className="text-base font-normal text-gray-50 dark:text-gray-400 mt-4">
              <b>Key Contributions & Qualities:</b>
            </p>

            <ul className="list-disc list-inside text-gray-50 dark:text-gray-400">
              <li>
                Developed and optimized UI using Next.js, Tailwind CSS, and
                React hooks.
              </li>
              <li>
                Designed a fully responsive admin dashboard with mobile-first
                principles.
              </li>
              <li>
                Built real-time chat support functionality using WebSockets and
                REST APIs.
              </li>
              <li>
                Collaborated with backend developers to ensure smooth
                integration of APIs.
              </li>
              <li>
                Enhanced performance and accessibility of frontend components.
              </li>
              <li>
                Created reusable UI components, improving development efficiency
                across teams.
              </li>
              <li>
                Engaged in daily stand-ups, sprint planning, and code reviews in
                an Agile environment.
              </li>
              <li>
                Continuously monitored and improved user experience using
                analytics and feedback.
              </li>
            </ul>
          </li>
          <li className="mb-10 ml-4">
            <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
            <time className="mb-1 text-sm font-normal leading-none text-gray-50 dark:text-gray-500">
              September 2023 - January 2025
            </time>
            <h3 className="text-lg font-semibold  dark:text-white">
              Product Engineer (Full Stack Developer)
            </h3>
            <h6 className="text-sm font-semibold  dark:text-white">
              Advenio TecnoSys Private Limited
            </h6>

            <p className="text-base font-normal text-gray-50 dark:text-gray-400 mt-2">
              At Advenio Tecnosys, I have been working as a Product Engineer,
              focusing on both front-end and back-end development. My role
              involves designing and implementing scalable web applications,
              ensuring a seamless user experience, and collaborating with
              cross-functional teams to deliver high-quality products. I am
              responsible for writing clean, efficient, and maintainable code
              while staying up-to-date with the latest industry trends and
              technologies.
            </p>
            <p className="text-base font-normal text-gray-50 dark:text-gray-400 mt-4">
              <b>Key Qualities:</b>
            </p>
            <ul className="list-disc list-inside text-gray-50 dark:text-gray-400">
              <li>
                Proficient in modern JavaScript frameworks and libraries such as
                React and Node.js.
              </li>
              <li>
                Strong understanding of database management and server-side
                development.
              </li>
              <li>
                Excellent problem-solving skills and ability to troubleshoot
                complex issues.
              </li>
              <li>
                Effective communication and collaboration with team members and
                stakeholders.
              </li>
              <li>
                Ability to manage multiple tasks and projects simultaneously.
              </li>
              <li>
                Continuous learner, always seeking to enhance skills and
                knowledge.
              </li>
              <li>
                Strong attention to detail and commitment to delivering
                high-quality work.
              </li>
            </ul>
          </li>
          <li className="mb-10 ml-4">
            <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
            <time className="mb-1 text-sm font-normal leading-none text-gray-50 dark:text-gray-500">
              July 2023 - September 2023
            </time>
            <h3 className="text-lg font-semibold text-gray-50 dark:text-white">
              Product Intern (Full Stack Developer)
            </h3>
            <h6 className="text-sm font-semibold  dark:text-white">
              Advenio TecnoSys Private Limited
            </h6>
            <p className="text-base font-normal text-gray-50 dark:text-gray-400 mt-2">
              During my internship at Advenio Tecnosys, I gained hands-on
              experience in full stack development, working closely with senior
              developers to learn best practices in coding, debugging, and
              deploying web applications. I contributed to various projects,
              enhancing my understanding of the development lifecycle and
              improving my technical skills in a real-world environment.
            </p>
            <p className="text-base font-normal text-gray-50 dark:text-gray-400 mt-4">
              <b>Key Achievements:</b>
            </p>
            <ul className="list-disc list-inside text-gray-50 dark:text-gray-400">
              <li>
                Successfully developed and deployed a feature-rich web
                application within the internship period.
              </li>
              <li>
                Improved team efficiency by creating reusable components and
                optimizing code structure.
              </li>
              <li>
                Received positive feedback for problem-solving abilities and
                quick adaptation to new technologies.
              </li>
            </ul>
          </li>
          <li className="mb-10 ml-4">
            <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
            <time className="mb-1 text-sm font-normal leading-none text-gray-50 dark:text-gray-500">
              July 2022 - April 2023
            </time>
            <h3 className="text-lg font-semibold text-gray-50 dark:text-white">
              Full Stack Web Development Bootcamp
            </h3>
            <h6 className="text-sm font-semibold  dark:text-white">
              Masai School
            </h6>
            <p className="text-base font-normal text-gray-50 dark:text-gray-400 mt-2">
              Completed an intensive Full Stack Web Development course at Masai
              School, focusing on the MERN stack (MongoDB, Express.js, React,
              Node.js). The bootcamp provided over 1200+ hours of hands-on
              coding experience, covering front-end and back-end development,
              data structures and algorithms, and industry best practices.
            </p>
            <p className="text-base font-normal text-gray-50 dark:text-gray-400 mt-4">
              <b>Key Achievements:</b>
            </p>
            <ul className="list-disc list-inside text-gray-50 dark:text-gray-400">
              <li>
                Developed multiple full-stack projects, both individually and
                collaboratively.
              </li>
              <li>
                Gained expertise in JavaScript, React, Node.js, and database
                management.
              </li>
              <li>
                Enhanced problem-solving skills by solving 300+ data structures
                and algorithms problems.
              </li>
              <li>
                Received 100+ hours of soft skills training to improve
                communication and teamwork abilities.
              </li>
              <li>
                Participated in coding challenges and hackathons to test and
                refine skills.
              </li>
            </ul>
          </li>
        </ol>
      </div>
    </div>
  );
};

export default Experience;
